import * as React from 'react';

import { useSelector } from 'react-redux';
import { LastChanceDiscountIllustration } from '../../../../components/LastChanceDiscount';
import { TopPromosIllustration } from '../../../../components/TopPromos';
import { selectPromoCompilationLogoUrls } from '../../../../selectors/promoComparison';
import { TPromoCompilationType } from '../../../../types/promoSelection';

export interface IPromoCompilationIllustrationProps {
  type: TPromoCompilationType;
}

export const PromoCompilationIllustrationContainer: React.FC<IPromoCompilationIllustrationProps> = ({ type }) => {
  const logosUrls = useSelector(selectPromoCompilationLogoUrls);

  switch (type) {
    case 'topPromos':
      return <TopPromosIllustration logosUrls={logosUrls} />;
    case 'lastChanceDiscount':
      return <LastChanceDiscountIllustration />;
  }
};
